import { Metrics } from 'remotes/@api/audit_v0';
import { AuditService, Review } from '../services/AuditService';

type Metric = Omit<Metrics, 'userId' | 'sessionId'>;

/**
 * Loader of data for global stores.
 */
export class Audit {
    private isAuthorizationProcessed: boolean;

    /**
     *
     */
    constructor() {
        this.isAuthorizationProcessed = false;
        // this.reviewMetrics = [];
        // this.eventMetrics = [];
        // this.runtimeMetrics = [];
    }

    /**
     * @description SetIsAuthorizationProcessed.
     * @param {boolean} isAuthorizationProcessed - IsAuthorizationProcessed.
     */
    public setIsAuthorizationProcessed(isAuthorizationProcessed: boolean) {
        this.isAuthorizationProcessed = isAuthorizationProcessed;
        // if (isAuthorizationProcessed) {
        //     if (this.reviewMetrics.length)
        //         AuditService.review(this.reviewMetrics).then();
        //     if (this.eventMetrics.length)
        //         AuditService.event(this.eventMetrics).then();
        //     if (this.runtimeMetrics.length)
        //         AuditService.runtime(this.runtimeMetrics).then();
        // }
    }

    /**
     * @description Runtime.
     * @param {Review} review - Review.
     */
    review(review: Review) {
        AuditService.review(review, this.isAuthorizationProcessed).then();
    }

    /**
     * @description Event.
     * @param {Metric | Array<Metric>} metrics - Metric.
     */
    event(metrics: Metric | Array<Metric>) {
        if (Array.isArray(metrics))
            AuditService.event(metrics, this.isAuthorizationProcessed).then();
        else
            AuditService.event([metrics], this.isAuthorizationProcessed).then();
    }

    /**
     * @description Event.
     * @param {Metric | Array<Metric>} metrics - Metric.
     */
    runtime(metrics: Metric | Array<Metric>) {
        if (Array.isArray(metrics))
            AuditService.runtime(metrics, this.isAuthorizationProcessed).then();
        else
            AuditService.runtime(
                [metrics],
                this.isAuthorizationProcessed,
            ).then();
    }
}

export const audit = new Audit();
